class Elements {
    constructor(
        permissionId,
        segmentId,
        id,
        name,
        from,
        to,
        applyOnNonHolidays,
        applyOnHolidays,
        requiredPin,
        requiredCacheo,
        requiredPassBack,
        porcentCacheo) {
        this.permissionId = permissionId;
        this.segmId = segmentId;
        this.numberSequence
        this.id = id;
        this.name = name;
        this.from = from;
        this.fromMinutes = Elements.convertMinutesToHHMM(from);
        this.to = to;
        this.toMinutes = Elements.convertMinutesToHHMM(to);
        this.applyOnNonHolidays = applyOnNonHolidays;
        this.applyOnHolidays = applyOnHolidays;
        this.applyOnNonHolidaysIcon = applyOnNonHolidays ? "✅" : "";
        this.applyOnHolidaysIcon = applyOnHolidays ? "✅" : "";
        this.requiredPin = requiredPin;
        this.requiredPinIcon = Elements.getIconForRequirement(this.requiredPin);
        this.requiredCacheo = requiredCacheo;
        this.requiredCacheoIcon = Elements.getIconForRequirement(this.requiredCacheo);
        this.requiredPassBack = requiredPassBack;
        this.requiredPassBackIcon = Elements.getIconForRequirement(this.requiredPassBack);
        this.porcentCacheo = porcentCacheo;
    }

    static fromJson({
        permisoId,
        segmId,
        elemId,
        nombre,
        desde,
        hasta,
        aplNoFeriados,
        aplFeriados,
        reqPin,
        reqCacheo,
        reqPassBack,
        porcenCacheo
    }) {
        return new Elements(
            permisoId,
            segmId,
            elemId,
            nombre,
            desde,
            hasta,
            aplNoFeriados,
            aplFeriados,
            reqPin,
            reqCacheo,
            reqPassBack,
            porcenCacheo
        );
    }

    static getIconForRequirement(value) {
        switch (value) {
            case 0:
                return '❌'; // No
            case 1:
                return '✅'; // Sí
            case 2:
                return '➖'; // No definido (alternativa)
            default:
                return '➖'; // Por si acaso
        }
    }

    static convertMinutesToHHMM(minutes) {
        const hours = Math.floor(minutes / 60);
        const minutesRemainder = minutes % 60;

        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutesRemainder).padStart(2, "0");

        return `${formattedHours}:${formattedMinutes}`;
    }
}

export default Elements;
